import { Box, CircularProgress, Typography, Stack } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import MzAlert from "@markaaz/ui/MzAlert";
import Section from "components/common/Section";
import DetailsRow from "./DetailsRow";
import { Connection } from "assets/icons";

const sx = {
  section: {
    display: "flex",
    gap: "20px",
    marginBottom: "40px",
    height: "50px",
    alignItems: "center"
  }
};

const PartnerHosted = ({
  pageData,
  inputValues,
  partnerHostedData,
  showInputBox,
  loading,
  disableSaveButton,
  connectionLoading,
  partnerHostedAlert,
  connectionStatusAlert,
  onEdit,
  onSubmit,
  onDownload,
  onInputChange,
  onTestConnection,
  onAlertClose
}) => {
  const { connectionData, keyData } = pageData;
  const fileUrl = (partnerHostedData?.keys || []).map((item) => item?.publicKeyFileLink);
  const fileName = partnerHostedData?.keys[0]?.publicKeyFileName;

  const handleSubmit = async () => {
    const formData = {
      userName: inputValues.userName || partnerHostedData?.connection.userName,
      serverName: inputValues.serverName || partnerHostedData?.connection.serverName,
      port: inputValues.port || partnerHostedData?.connection.port
    };
    await onSubmit(formData);
  };

  return (
    <Box>
      <Section pageData={connectionData}>
        {connectionData.items.map((item, index) => {
          let editInput = false;
          const inputName = item.inputName;
          const rowData = partnerHostedData?.connection?.[item.inputName] || "";
          editInput = showInputBox === inputName || rowData === "";
          const values = inputValues?.[inputName];
          return (
            <DetailsRow
              isConnection={true}
              label={item.label}
              rowData={rowData}
              inputName={inputName}
              values={values}
              showInputBox={editInput}
              onEdit={onEdit}
              showEditButton={true}
              onInputChange={onInputChange}
            />
          );
        })}
      </Section>
      {partnerHostedData?.connection && (
        <Box sx={sx.section}>
          <MzButton startIcon={<Connection />} onClick={onTestConnection}>
            <Typography variant="button2">Test Connection</Typography>
          </MzButton>
          {connectionLoading && <CircularProgress size={33} />}
          {connectionStatusAlert.message && (
            <Box>
              <MzAlert
                sx={{ maxWidth: "600px", alignItems: "center" }}
                severity={connectionStatusAlert.type === "success" ? "success" : "error"}
                onClose={() => {
                  onAlertClose("tc");
                }}
              >
                {connectionStatusAlert.message}
              </MzAlert>
            </Box>
          )}
        </Box>
      )}
      <Stack direction="row" gap={10} alignItems="center">
        <MzButton
          variant="contained"
          size="large"
          onClick={handleSubmit}
          loading={loading}
          disabled={disableSaveButton}
        >
          Save
        </MzButton>
        {partnerHostedAlert.message && (
          <MzAlert
            sx={{ alignItems: "center" }}
            severity={partnerHostedAlert.type === "success" ? "success" : "error"}
            onClose={() => {
              onAlertClose("phs");
            }}
          >
            {partnerHostedAlert.message}
          </MzAlert>
        )}
      </Stack>

      <Section pageData={keyData}>
        {keyData.items.map((item, index) => {
          return (
            <DetailsRow
              isKeys={true}
              isPartnerHosted={true}
              label={item.label}
              onDownload={onDownload}
              fileUrl={fileUrl}
              fileName={fileName}
            />
          );
        })}
      </Section>
    </Box>
  );
};

export default PartnerHosted;
